import type { CollectionAgreement } from './collectionAgreementModel';
import type { CollectionPolicy, ReceivingAccountKind } from './collectionModel';

export const canGenerateBoleto = (kind: ReceivingAccountKind): boolean => kind !== 'ESCROW';

export const withAccountKind = (agreement: CollectionAgreement, kind: ReceivingAccountKind): CollectionAgreement => ({
    ...agreement,
    receivingAccountKind: kind,
    payment: { ...agreement.payment, instruction: canGenerateBoleto(kind) ? agreement.payment.instruction : 'TRANSFER' },
});

export const withGenerateBoleto = (agreement: CollectionAgreement, generate: boolean): CollectionAgreement => ({
    ...agreement,
    payment: { ...agreement.payment, instruction: generate && canGenerateBoleto(agreement.receivingAccountKind) ? 'BOLETO' : 'TRANSFER' },
});

export const policyHasPhase = (policy: CollectionPolicy | undefined, phase: 'preventive' | 'overdue'): boolean =>
    Boolean(policy?.schedules?.[phase]);

export const withPolicy = (agreement: CollectionAgreement, policy: CollectionPolicy | undefined): CollectionAgreement => ({
    ...agreement,
    policyId: policy?.id ?? '',
    collectionOrder: agreement.collectionOrder.map(step => ({
        ...step,
        preventive: step.preventive && policyHasPhase(policy, 'preventive'),
        overdue: step.overdue && policyHasPhase(policy, 'overdue'),
    })),
});
